import { CssBaseline, GlobalStyles } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import RefineWrapper from "RefineWrapper";
import { AxiosProvider } from "provider/AxiosProvider";
import { BrowserRouter } from "react-router-dom";
import { customTheme } from "./customTheme";

function App() {
  return (
    <ThemeProvider theme={customTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <GlobalStyles styles={{ html: { WebkitFontSmoothing: "auto" } }} />
        <AxiosProvider>
          <BrowserRouter>
            <RefineWrapper />
          </BrowserRouter>
        </AxiosProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
